import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";

import  JsBarcode from "jsbarcode";

@Component({
    selector: "app-barcode-generator",
    templateUrl: "./barcode-generator.component.html",
    styleUrls: ["./barcode-generator.component.scss"],
    standalone: false
})
export class BarcodeGeneratorComponent implements AfterViewInit, OnChanges {
  elementType = "canvas";
  @Input() value = "Testing1234";
  @Input() barCodeType = "CODE128";
  @ViewChild("barcodeCanvas") barcodeCanvas!: ElementRef<HTMLCanvasElement>;

  codeList: string[] = [
    "",
    "CODE128",
    "CODE128A",
    "CODE128B",
    "CODE128C",
    "UPC",
    "EAN8",
    "EAN5",
    "EAN2",
    "CODE39",
    "ITF14",
    "MSI",
    "MSI10",
    "MSI11",
    "MSI1010",
    "MSI1110",
    "pharmacode",
    "codabar",
  ];

  constructor() {}

  ngAfterViewInit(): void {
    this.renderBarcode();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.barcodeCanvas && (changes["value"] || changes["barCodeType"])) {
      this.renderBarcode();
    }
  }

  /******************************************** bar code ******************************************/
  private renderBarcode(): void {
    const canvas = this.barcodeCanvas?.nativeElement;
    if (!canvas || !this.value) {
      return;
    }

    try {
      JsBarcode(canvas, this.value, {
        format: this.barCodeType,
      });
    } catch {
      // Invalid barcode value/format — skip render
    }
  }

  get values(): string[] {
    return this.value.split("\n");
  }
}
